/**
 * Angular core imports
 */
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
/**
 * External dependency
 */
import { OwlOptions } from 'ngx-owl-carousel-o';
import { EVENT_NAME } from '../../analytics-event/analytics.constant';
/**
 * Constant Imports
*/
import { NUMBERS, COMMUNITY_LIST_TYPE, CAROUSEL, SPLIT, SCREEN_NAME, PRODUCT_TYPE_CONSTANT, PRODUCT_TYPE_CONSTANT_NAME, ACTION_ON, CTA_TYPE, ACTION_TYPE } from '../../constants/app.constants';
/**
 * Model Imports
*/
import { CommunityList, CommunityConfirmation, ConfirmationModalData, MyCommunityList } from '../../onboarding/interface/global.model';
/**
 * Service imports.
*/
import { NewLanguageService } from '../../dataservices/new-language/new-language.service';
import { FunCollectionService } from '../../common/common-functions/fun-collection.service';
import { AppearedCards } from 'src/app/directives/intersection/appear.interface';

/**
 * sdk imports
 */
import { Analytics } from 'analytics2.0';

@Component({
  selector: 'app-public-community-card',
  templateUrl: './public-community-card.component.html',
  styleUrls: ['./public-community-card.component.scss']
})
export class PublicCommunityCardComponent implements OnInit {
/**
 * @community holds a single community object
 * @translations holds translation text
 * @pOffset holds current item index
 */
@Input() community: CommunityList;
@Input() myCommunity: MyCommunityList;
@Input() translations: { [key: string]: string } = {};
@Input() pOffset: number;
@Input() callingFrom = '';
@Input() callFromScreen = '';
@Input() carouselType : string;
/**
 * Emit the filter key outside.
 * @emitReloadCommunityList emits reload community list event
 */
 @Output() emitViewAll: EventEmitter<string> = new EventEmitter();
 @Output() emitCommunityDetail: EventEmitter<string> = new EventEmitter();
 @Output() emitReloadCommunityList: EventEmitter<boolean> = new EventEmitter();

  /**
  * Owl carousel options.
  */
  public customOptions: OwlOptions = {
    items: 11,
    loop: false,
    mouseDrag: false,
    touchDrag: true,
    pullDrag: true,
    dots: false,
    navSpeed: 700,
    navText: ['<i class="prev-slider position-absolute"></i>', '<i class="next-slider position-absolute"></i>'],
    nav: true,
    autoWidth: true,
    autoplay: false,
    margin: 16,
    responsive: {
      0: {
        items: 1.35
      },
      340: {
        items: 1.5
      },
      420: {
        items: 2
      },
      540: {
        items: 2.25
      },
      600: {
        items: 2.5
      },
      700: {
        items: 3
      },
      760: {
        items: 3.65
      }
    }
  };
  /**
   * Number constant
   */
  public numbers = NUMBERS;
  public confirmationModal = false;
  public confirmationText: ConfirmationModalData =
    {
      headingText: '',
      cancelButtonText: '',
      allowButtonText: '',
      bodyText: ''
    };
  public confirmedCommunity: CommunityConfirmation;
  public callFrom = CAROUSEL.GRANDROUND;
  public numberOfItem: number;
  /**
   * Screen name constant
   */
  public screen = SCREEN_NAME;

  /**
   * Session time object.
   */
  public sessiontime = { 'start_time': '', 'end_time': '' };

  constructor(public mls: NewLanguageService,
    public fcs: FunCollectionService,
    private analyticSdk: Analytics,
    public router: Router) {
    this.confirmationText.bodyText = this.mls.languageText.community.key91;
    this.confirmationText.headingText = this.mls.languageText.community.key92;
    this.confirmationText.allowButtonText = this.mls.languageText.community.key93;
    this.confirmationText.cancelButtonText = this.mls.languageText.community.key94;
    /**
     * Set start time on component cteation.
     */
    const d = new Date();
    this.sessiontime.start_time = d.getTime().toString();
  }


  ngOnInit(): void {
    this.numberOfItem = this.community.list.length;
  }

  /**
   * Emits event for view all click
   */
  viewAllHandler(): void {
    if (this.carouselType === CAROUSEL.MY_COMMUNITY_CAROUSEL) {
      this.fcs.navigateToCommunityListing(CAROUSEL.MY_COMMUNITY_CAROUSEL);
    }
    else {
      this.emitViewAll.emit(COMMUNITY_LIST_TYPE.PUBLIC_COMMUNITY);

      const d = new Date();
      this.sessiontime.end_time = d.getTime().toString();
    }
  }

  /**
   * Emits event for community details page visit
   * @param communityId
   */
  navigateTocommunityDetailHandler(communityId, listItem): void {
    this.emitCommunityDetail.emit(communityId);

    const start_time = new Date().getTime().toString();
    /**
     * Set analyics data on click.
     */
    if (this.callingFrom === SCREEN_NAME.COMMUNITY_DASHBOARD || this.callingFrom === SCREEN_NAME.PUBLIC_COMMUNITIES_LIST) {
      this.analyticSdk.analyticService.CLICK(PRODUCT_TYPE_CONSTANT_NAME.COMMUNITY,listItem?.da_id, this.callingFrom, CTA_TYPE.CARD, ACTION_TYPE.CLICK,ACTION_ON.COMMUNITY, null);
    }
  }

  /**
   * Confirmation withdraw request.
   */
  withdrawConfirmation(communityConfirmation: CommunityConfirmation): void {
    this.confirmedCommunity = communityConfirmation;
    this.confirmationModal = communityConfirmation.openModal;
  }
  /**
   * Allow withdraw request.
   */
  allowAction(isAllow: boolean): void {
    if (isAllow) {
      this.resetConfirmModal();

      const start_time = new Date().getTime().toString();
      this.analyticSdk.analyticService.CLICK(PRODUCT_TYPE_CONSTANT_NAME.COMMUNITY,this.confirmedCommunity.community?.da_id, this.confirmedCommunity.callingFrom !== '' ? this.confirmedCommunity.callingFrom : SCREEN_NAME.GR_PUBLIC_CAROUSEL, CTA_TYPE.BUTTON, ACTION_TYPE.CLICK,ACTION_ON.WITHDRAW_REQUEST_CONFIRM, null);
    }
  }
  /**
   * Reset confirm modal.
   */
  resetConfirmModal(): void {
    this.confirmationModal = false;
  }

  /**
   * reload community list
   */
  reloadCommunityList(): void {
    this.emitReloadCommunityList.emit(true);
  }

  /**
   * Get the appeared card product type and id.
   */
  getAppearedIds(card): string {
    if (card && card.da_id) {
      return `${PRODUCT_TYPE_CONSTANT.COMMUNITY}${SPLIT}${card.da_id}`;
    }
  }

  /**
   * Collects all the appeared cards on the DOM view.
   */
  onCardAppear(cards: AppearedCards): void {
    if (cards) {
      this.fcs.onHorizontalCardAppear(cards, this.callFromScreen === CAROUSEL.GRANDROUND ? SCREEN_NAME.GRAND_ROUND : '');
    }
  }
}
